import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { organizationSettings } from './organizationSettingsSlice';
import { organizations } from './organizationsSlice';
import { sealsAndSignatures } from './sealsAndSignaturesSlice';
import { userData } from './userDataSlice';

export const store = configureStore({
  reducer: {
    sealsAndSignatures,
    userData,
    organizations,
    organizationSettings,
    spinnerMessages,
    logInData,
    environment,
    notifications,
    theme,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
